import { render } from "./blog.html?vue&type=template&id=619a785e&ts=true"
import script from "./blog.vue?vue&type=script&lang=ts"
export * from "./blog.vue?vue&type=script&lang=ts"

import "./blog.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__